/**
 * Mixin модального окна подтверждения пароля
 */

import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            form: {
                password: this.password,
            },
            passwordVerifyPending: false,
        }
    },
    computed: {
        ...mapState('passwordVerify', ['password', 'show']),
    },
    watch: {
        password(value) {
            if (!this.form.password) {
                this.form.password = value;

                if (this.passwordVerifyPending && this.onVerifiedPassword) {
                    this.onVerifiedPassword();
                    this.passwordVerifyPending = false;
                }
            }
        },
        show(value) {
            // Если происходит закрытие окна и пароль при этом не был подтвержден
            if (!value && !this.password) {
                // Отменим статус ожидания подтверждения
                this.passwordVerifyPending = false;
            }
        },
    },
    methods: {
        /**
         * Верификация пароля
         * @returns {boolean}
         */
        verifyPassword() {
            let isPasswordVerified = !!this.form.password;

            // Если ранее пользователем не был подтвержден текущий пароль
            if (!isPasswordVerified) {
                this.showPasswordVerifyModal();
                this.passwordVerifyPending = true;
            }

            return isPasswordVerified;
        },
        /**
         * Методы vuex-модуля `passwordVerify` (модального окна
         *  подтверждение пароля)
         *  showPasswordVerifyModal - показ модального окна подтверждения пароля
         *  unsetPassword - удаление текущего пароля из хранилища vuex
         */
        ...mapActions('passwordVerify', [
            'showPasswordVerifyModal',
        ]),
    },
}
